'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var Cookies = _interopDefault(require('js-cookie'));

var DEFAULT_IB_AUTH_COOKIE_NAME = 'ibjwt';

var getAuthCookie = function getAuthCookie() {
	var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_IB_AUTH_COOKIE_NAME;

	try {
		return Cookies.getJSON(name);
	} catch (error) {
		return { error: error.message };
	}
};

var removeAuthCookie = function removeAuthCookie() {
	var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_IB_AUTH_COOKIE_NAME;
	var domain = arguments[1];

	Cookies.remove(name, { domain: domain });
};

exports.DEFAULT_IB_AUTH_COOKIE_NAME = DEFAULT_IB_AUTH_COOKIE_NAME;
exports.getAuthCookie = getAuthCookie;
exports.removeAuthCookie = removeAuthCookie;
